import * as Sentry from '@sentry/vue';

export default {
  install(Vue) {
    Vue.prototype.$sentryMessage = (tag, message, context = {}) => {
      if (!Sentry || !message) return;
      if (tag) {
        Sentry.setTag('module', tag);
      }
      if (context && typeof context === 'object') {
        Sentry.setContext('context', context);
      }
      Sentry.captureMessage(message, {
        tags: { manual: true },
      });
    };
  },
};
